import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeleteInconsistency = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (inconsistencyId: string) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/inconsistency/${inconsistencyId}`,
        fetchConfig,
      );

      if (response.status === 403) {
        toast.error('You are not allowed to delete this inconsistency');
        throw new Error('Failed to delete inconsistency');
      }

      if (!response.ok) {
        toast.error('Failed to delete inconsistency');
        throw new Error('Failed to delete inconsistency');
      }

      trackCustomEvent(TrackingEventsV2.InconsistencyDelete, { matterId, inconsistencyId });
      toast.success('Inconsistency deleted');
      queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetInconsistencies, { subsetId }] });
    },
  });
};
